export const MaxCommitMessageLength = 2048;
